module.exports = __webpack_public_path__ + "media/images/icons/academy-maths-d713781945bc3f8b07ccd4faf62642a0.svg";